export default __webpack_public_path__ + "static/media/CarImages.K2700Medium2.a7973844.jpg";